// extracted by mini-css-extract-plugin
export default {"dialog":"SlideshowViewModal_dialog__MDhkN"};